import { render, staticRenderFns } from "./SettingsRewrite.vue?vue&type=template&id=46a3f33f&scoped=true&"
import script from "./SettingsRewrite.vue?vue&type=script&lang=js&"
export * from "./SettingsRewrite.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRewrite.vue?vue&type=style&index=0&id=46a3f33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a3f33f",
  null
  
)

export default component.exports